import React from 'react';
import Icon from './icon';

const ClockIcon = React.forwardRef((props, ref) => (
  <Icon
    ref={ref}
    name="info"
    viewBox="0 0 18 18"
    {...props}
    renderComponent={({ color }) => (
      <React.Fragment>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="transparent"
          d="M8.99562 1C4.57763 1.00242 0.997986 4.58566 1 9.00365C1.00202 13.4216 4.58493 17.0016 9.00292 17C13.4209 16.9984 17.0012 13.4158 17 8.99781C16.9994 6.8757 16.1557 4.84077 14.6545 3.34082C13.1534 1.84088 11.1177 0.99884 8.99562 1V1Z"
          stroke="white"
          strokeWidth="1.5"
        />
        <path d="M9 4L9.00197 9L12 8.99792" stroke={color} strokeWidth="1.5" />
      </React.Fragment>
    )}
  />
));

ClockIcon.displayName = 'ClockIcon';

export default ClockIcon;
